import React from "react";
import { Link } from "react-router-dom";
import Cell from "../../../../componant/Table/cell";

const UserNameLink = ({ userId, name, planName, email }) => {
  const displayName = `${name || "User Deleted"}${planName ? ` - ${planName}` : ""}`;

  if (!userId) {
    return <Cell text={displayName} subtext={email} bold="bold" />;
  }

  return (
    <Link
      to={`/dash/view-user/${userId}`}
      className="inline-block max-w-full hover:underline"
    >
      <Cell text={displayName} subtext={email} bold="bold" />
    </Link>
  );
};

export default UserNameLink;
